import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Txt } from "../../../../components/Txt";
import { useTextSeparatorWithDirectionalMark } from "../../../../hooks/useTextSeparatorWithDirectionalMark";
export const AddressStreetInfoUnitedArabEmirates = ({ city, premise, landmark, streetName, streetAdditional, neighborhood, }) => {
    const { joinWithSeparator } = useTextSeparatorWithDirectionalMark();
    const firstRow = joinWithSeparator(streetAdditional, premise);
    const secondRow = joinWithSeparator(streetName, neighborhood, city);
    return (_jsxs(_Fragment, { children: [_jsx(Txt, { children: firstRow }), _jsx(Txt, { children: secondRow }), landmark && _jsx(Txt, { children: landmark })] }));
};
//# sourceMappingURL=AddressStreetInfoUnitedArabEmirates.js.map